import PopupModal from "./PopupModal";

export default PopupModal;